export const state = {
  notifications: []
}

export const getters = {}

export const mutations = {
  PUSH_NOTIFICATION: (state, notification) => {
    state.notifications.push({
      ...notification,
      id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    })
  },
  REMOVE_NOTIFICATION: (state, notificationToRemove) => {
    state.notifications = state.notifications.filter(notification => {
      return notification.id != notificationToRemove.id;
    })
  }
}

export const actions = {
  addNotification(context, notification) {
    context.commit('PUSH_NOTIFICATION', notification);
  },
  removeNotification(context, notification) {
    context.commit('REMOVE_NOTIFICATION', notification);
  }
}

export default {
  state,
  getters,
  actions, // asynchronous
  mutations, // synchronous
}